/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConfigService } from '../app-config/app-config.service';
import { IAvailableTranslations } from './models/available-translations.model';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRouteSnapshot } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AvailableTranslationsService {
  private readonly defaultLanguage = 'en';

  constructor(
    protected http: HttpClient,
    private appConfigService: AppConfigService,
    private translateService: TranslateService
  ) {}

  /** Fetches available and app config translations and adds them to the translations service. */
  getAvailableTranslations(): Observable<IAvailableTranslations> {
    const cdnUrl = this.appConfigService.getEnvValue<string>('cdnUrl');
    this.translateService.addLangs(this.appConfigService.getAppValue<string[]>('locales'));

    const url = `${cdnUrl.replace(
      /\/?$/,
      '/'
    )}translations/available-languages-${this.appConfigService.getAppValue<string>('appId')}.json`;

    return this.http.get<IAvailableTranslations>(url);
  }

  /**
   * Configures the translation service to use the specified language
   * @param route ActivatedRouteSnapshot
   * @returns language code determined for the app
   */
  getLanguageCode(route: ActivatedRouteSnapshot): string {
    /* Check if route language is provided for */
    let lang = route.params['lang'];
    const locales = this.translateService.getLangs();
    if (!locales?.includes(lang)) {
      lang = this.defaultLanguage;
    }

    return lang;
  }

  getDefaultLanguageCode(): string {
    return this.defaultLanguage;
  }
}
